var path = '/common/component/video/directive/tpl/tm-volume-bar.html';
var html = "<div class=horizontalVolumeBar> <div class=volumeBackground ng-click=onClickVolume($event) ng-mousedown=onMouseDownVolume() ng-mouseup=onMouseUpVolume() ng-mousemove=onMouseMoveVolume($event) ng-mouseleave=onMouseLeaveVolume()> <div class=volumeValue></div> <div class=volumeClickArea></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/component/video/directive/tpl/tm-volume-bar.html
// module id = 298
// module chunks = 0 1 2 3 4